import { render, staticRenderFns } from "./ShowUserComponent.vue?vue&type=template&id=11df5dd3&scoped=true&"
import script from "./ShowUserComponent.vue?vue&type=script&lang=js&"
export * from "./ShowUserComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11df5dd3",
  null
  
)

export default component.exports